import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    messages : {}
}

const messagesSlice = createSlice({
    name: "messages",
    initialState,
    reducers: {
        setAllUserMessages(state, action) {
            state.messages = action.payload
        },
        addNewMessages(state, action){
            const { messageId, messages: newMsgs } = action.payload;

            if (!state.messages[messageId]) {
                state.messages[messageId] = [];
            }

            state.messages[messageId].push(...newMsgs);

        },
        editMessage(state, action){
            const { messageId, messages } = action.payload;
            const updated = messages[0];

            if (!state.messages[messageId]) {
                return
            }

            const idx = state.messages[messageId].findIndex(m => m.id === updated.id);
            if (idx !== -1) {
                state.messages[messageId][idx] = updated;
            }

        },
        deleteMessage(state, action) {
            const { messageId, messages } = action.payload;
            const message = messages[0];

            const thread = state.messages[messageId];
            if (!thread) return;                        
          
            const idx = thread.findIndex(m => m.id === message.id);
            if (idx !== -1) {
              thread.splice(idx, 1);
            }
        },
        addNewMessage(state, action){
            const { messageId, message } = action.payload;

            if (!state.messages[messageId]) {
                state.messages[messageId] = [];
            }

            state.messages[messageId].push(message);
        }
    }
});

export const { setAllUserMessages, addNewMessage, addNewMessages, editMessage, deleteMessage }  = messagesSlice.actions

export default messagesSlice.reducer